import { MemberModel } from "lib/types/members/MemberModel";

export function updateMemberDetails(user: MemberModel) {
  //coming soon: users will be able to update their details
  return new Promise<null>((resolve, reject) => setTimeout(resolve, 2000));
}
